import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box, Button, CircularProgress, TextField, Typography, useTheme } from '@mui/material';
import Link from 'next/link';
import { NavigationPath } from 'src/types/navigation';
import { ThemeProps } from 'theme';
import resetPassword from 'src/rest/auth/resetPassword';

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
`;

const BackToLogin = styled.a<ThemeProps>`
  ${({ theme }: ThemeProps) => `
    color: ${theme.palette.secondary.main};
  `}
  cursor: pointer;
`;

const ResetPassword = () => {
  const theme = useTheme();
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordResetLinkSended, setPasswordResetLinkSended] = useState<boolean>(false);

  const sendPasswordResetLink = async () => {
    console.log("sendPasswordResetLink", email);
    setLoading(true);

    try {
      const result = await resetPassword({ email });
      console.log("RESET PASSWORD: ", result);
      setLoading(false);
      setPasswordResetLinkSended(true);

    } catch (error) {
      // TODO: error handling, so error with material ui https://material-ui.com/components/alert/ or https://material-ui.com/components/snackbars/#customized-snackbars
      setLoading(false);
      console.error(error);
    }
  };

  const inputFieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  return <Container>
    <Content>
      {passwordResetLinkSended
        ? <>
          <Typography component="div" variant="subtitle1" gutterBottom>
            <Box fontWeight="fontWeightBold" textAlign="center" m={1}>
              Check your email!
            </Box>
          </Typography>
          <Typography component="div" variant="subtitle2" gutterBottom>
            <Box fontWeight="fontWeightLight" textAlign="center" m={1}>
              A password reset message was sent to your email address. Please click the link in that message to reset your password.
            </Box>
            <Box fontWeight="fontWeightLight" textAlign="center" m={1}>
              If you do not receive the password reset message within a few moment, please check your spam folder.
            </Box>
          </Typography>
          <Box textAlign="center" p={2}>
            <Link href={NavigationPath.LOGIN}>
              <BackToLogin theme={theme}><b>Back to login</b></BackToLogin>
            </Link>
          </Box>
        </>
        : <>
          <Typography component="div" variant="subtitle1" gutterBottom>
            <Box fontWeight="fontWeightBold" textAlign="center" m={1}>
              Trouble Logging In?
            </Box>
            <Box fontWeight="fontWeightLight" textAlign="center" m={1}>
              Enter your email and we&apos;ll send you a link to get back into your account.
            </Box>
          </Typography>
          <TextField
            fullWidth
            size='small'
            margin="dense"
            autoFocus={true}
            label="Email address"
            style={{ marginTop: 32 }}
            InputLabelProps={{
              style: {
                fontWeight: "bold",
              },
              shrink: true,
            }}
            onChange={inputFieldChangeHandler}
          />
          <Button
            size="large"
            color="secondary"
            variant="contained"
            disabled={loading}
            style={{ marginTop: 48 }}
            onClick={sendPasswordResetLink}>
            {loading ? <CircularProgress size={25} style={{ color: "#fff" }} /> : "Send Login Link"}
          </Button>

          <Box textAlign="center" p={2}>
            <Link href={NavigationPath.LOGIN}>
              <BackToLogin theme={theme}>Back to login</BackToLogin>
            </Link>
          </Box>
        </>
      }

    </Content>
  </Container>;
};

export default ResetPassword;